import { applyMiddleware, createStore } from "redux";

import rootReducer from "./reducers/rootReducer";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";

const store = createStore( rootReducer, composeWithDevTools( applyMiddleware( thunk ) ) );

export type RootStore = ReturnType< typeof rootReducer >

export default store;